import React from 'react'
import styles from './UsageSelector.module.scss'
import { CheckBox } from 'components'
import { inject } from 'mobx-react'
import { ROUTING_STORE, GENERAL_STORE } from 'store'
import { Props } from './types'
import SkuAttribute from 'components/common/SkuAttribute'
import { Image, Sku } from 'models'

const UsageSelector = (props: Props) => {
  const {
    [ROUTING_STORE]: {
      location: { pathname }
    },
    [GENERAL_STORE]: { showInfo },
    isGeneral,
    setGeneral,
    image,
    additionalProps
  } = props

  const hideUsageOptions = pathname.startsWith('/persons') || pathname.startsWith('/brands')
  if (hideUsageOptions) return null

  const isThisAProductPage = pathname.startsWith('/products')

  const isImageSavedInDb = !!image.id

  const isSkuChecked = (sku: Sku) => {
    if (!isImageSavedInDb) return false

    return sku.images.some(img => img.id === image.id)
  }

  const handleSkuClick = (sku: Sku) => () => {
    if (!isImageSavedInDb) {
      showInfo('Seems image is not yet saved to Product gallery. Please save Product form first.')
      return
    }

    const { skus, setSkus } =
      additionalProps as {
        skus: Sku[]; setSkus: (skus: Sku[]) => void;
      }
    const skuIndex = skus.findIndex(s => s.id === sku.id)
    const cloneSku = { ...sku }
    const cloneSkus = [...skus]

    const removeImage = () => {
      cloneSku.images = cloneSku.images.filter(i => i.id !== image.id)
      save()
    }
    const addImage = () => {
      cloneSku.images = [...cloneSku.images, image as Image]
      save()
    }
    const save = () => {
      cloneSkus[skuIndex] = cloneSku
      setSkus(cloneSkus)
    }

    isSkuChecked(sku)
      ? removeImage()
      : addImage()
  }

  return (
    <div className={styles.container}>
      <h4>Image is used as:</h4>

      <div className={styles.checkBoxLine}>
        <CheckBox
          checked={isGeneral}
          onClick={() => setGeneral(!isGeneral)}
        /> general
      </div>

      {(isThisAProductPage && additionalProps && additionalProps.skus) &&
        <>
          <h4>For Product SKUs:</h4>

          <div className={styles.skusContainer}>
            {additionalProps.skus.map((sku: Sku, index) =>
              <div
                key={sku.id || index}
                className={styles.checkBoxLine}
                title={`SKU: ${sku.sku}`}
              >
                <CheckBox
                  checked={isSkuChecked(sku)}
                  onClick={handleSkuClick(sku)}
                />
                <div className={styles.attrContainer}>
                  {(sku.attributes || []).map(attr =>
                    <SkuAttribute
                      key={attr.value}
                      attribute={attr}
                      size='small'
                    />
                  )}
                  {(!sku.attributes || !sku.attributes.length) && 'default'}
                </div>
              </div>
            )}
          </div>
        </>
      }

    </div>
  )
}

export default inject(ROUTING_STORE, GENERAL_STORE)(UsageSelector)
